import { TUpdateAgentPreferenceBodySchema } from '@cloud-wave/neon-common-lib';

import { IApiRequestArgs } from 'lib/common/contexts/AgentPreferenceContext/api/IApiRequestArgs';

export const validateAgentAddress = async ({
  config,
  fetch_,
  location,
}: IApiRequestArgs & { location: TUpdateAgentPreferenceBodySchema['location'] }) => {
  const result = await fetch_(`${config.AGENT_SERVICE_V2_URL}/agent/${config.TENANT_ID}/preference/validate-address`, {
    body: JSON.stringify({ location: location }),
    method: 'POST',
  });

  return (await result.json()).data;
};
